import * as Types from '../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type CreateLoginCodeMutationVariables = Types.Exact<{
  input: Types.CreateLoginCodeInput
}>

export type CreateLoginCodeMutation = {
  __typename?: 'Mutation'
  createLoginCode?: {
    __typename?: 'CreateLoginCodePayload'
    success: boolean
    channel?: Types.LoginCodeChannelEnum | null
    aliceTel?: string | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const CreateLoginCodeDocument = `
    mutation CreateLoginCode($input: CreateLoginCodeInput!) {
  createLoginCode(input: $input) {
    success
    channel
    aliceTel
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useCreateLoginCodeMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<CreateLoginCodeMutation, TError, CreateLoginCodeMutationVariables, TContext>
) =>
  useMutation<CreateLoginCodeMutation, TError, CreateLoginCodeMutationVariables, TContext>(
    ['CreateLoginCode'],
    (variables?: CreateLoginCodeMutationVariables) =>
      fetchGql<CreateLoginCodeMutation, CreateLoginCodeMutationVariables>(
        CreateLoginCodeDocument,
        variables
      )(),
    options
  )
